module.exports = __webpack_public_path__ + "static/media/p208cover1.411f6131.png";